import { t } from "@/i18n-js/instance";
import {
  getPlanAddonPrice,
  getPlanAddonValue,
} from "@/react/helpers/planAddonHelpers";
import { planFeatures } from "@/react/helpers/plansHelpers";
import { planTiers } from "@circle-react/helpers/planHelpers";
import { Loader } from "@circle-react-uikit/Loader";
import { FeatureRow } from "../FeatureRow";
import { usePlans } from "../PlansContext";
import { SectionWrapper } from "./SectionWrapper";

export const CommunityAddons = () => {
  const { plans, isPlansLoading } = usePlans();

  if (isPlansLoading) {
    return <Loader center />;
  }

  const i18nRoot = "settings.billing.add_ons.manage";
  const addonsIncluded = "settings.billing.add_ons.included";

  return (
    <SectionWrapper sectionName={t("pricing_plans.section.community")}>
      <FeatureRow
        title={t("settings.billing.add_ons.manage.admins")}
        professional={t(`${i18nRoot}.admins_description`, {
          amount: getPlanAddonPrice(
            plans,
            planTiers.professional,
            planFeatures.max_admin_count,
          ),
        })}
        business={t(`${i18nRoot}.admins_description`, {
          amount: getPlanAddonPrice(
            plans,
            planTiers.business,
            planFeatures.max_admin_count,
          ),
        })}
        enterprise={t(`${i18nRoot}.admins_description`, {
          amount: getPlanAddonPrice(
            plans,
            planTiers.enterprise,
            planFeatures.max_admin_count,
          ),
        })}
      />

      <FeatureRow
        title={t("settings.billing.add_ons.manage.moderators")}
        professional={t(`${i18nRoot}.moderators_description`, {
          quantity: getPlanAddonValue(
            plans,
            planTiers.professional,
            planFeatures.max_moderator_count,
          ),
          amount: getPlanAddonPrice(
            plans,
            planTiers.professional,
            planFeatures.max_moderator_count,
          ),
        })}
        business={t(`${i18nRoot}.moderators_description`, {
          quantity: getPlanAddonValue(
            plans,
            planTiers.business,
            planFeatures.max_moderator_count,
          ),
          amount: getPlanAddonPrice(
            plans,
            planTiers.business,
            planFeatures.max_moderator_count,
          ),
        })}
        enterprise={t(`${i18nRoot}.moderators_description`, {
          quantity: getPlanAddonValue(
            plans,
            planTiers.enterprise,
            planFeatures.max_moderator_count,
          ),
          amount: getPlanAddonPrice(
            plans,
            planTiers.enterprise,
            planFeatures.max_moderator_count,
          ),
        })}
      />

      <FeatureRow
        title={t("settings.billing.add_ons.manage.spaces")}
        professional={t(`${i18nRoot}.spaces_description`, {
          quantity: getPlanAddonValue(
            plans,
            planTiers.professional,
            planFeatures.max_space_count,
          ),
          amount: getPlanAddonPrice(
            plans,
            planTiers.professional,
            planFeatures.max_space_count,
          ),
        })}
        business={t(`${i18nRoot}.spaces_description`, {
          quantity: getPlanAddonValue(
            plans,
            planTiers.business,
            planFeatures.max_space_count,
          ),
          amount: getPlanAddonPrice(
            plans,
            planTiers.business,
            planFeatures.max_space_count,
          ),
        })}
        enterprise={t(`${i18nRoot}.spaces_description`, {
          quantity: getPlanAddonValue(
            plans,
            planTiers.enterprise,
            planFeatures.max_space_count,
          ),
          amount: getPlanAddonPrice(
            plans,
            planTiers.enterprise,
            planFeatures.max_space_count,
          ),
        })}
      />

      <FeatureRow
        title={t("settings.billing.add_ons.manage.email_white_labeling")}
        professional={t(
          `settings.billing.add_ons.manage.email_white_labeling_description`,
          {
            amount: getPlanAddonPrice(
              plans,
              planTiers.professional,
              planFeatures.email_whitelist,
            ),
          },
        )}
        business={t(addonsIncluded)}
        enterprise={t(addonsIncluded)}
      />

      <FeatureRow
        title={t("settings.billing.add_ons.manage.profile_fields")}
        professional={t(
          `settings.billing.add_ons.manage.profile_fields_description`,
          {
            amount: getPlanAddonPrice(
              plans,
              planTiers.professional,
              planFeatures.profile_fields_enabled,
            ),
          },
        )}
        business={t(addonsIncluded)}
        enterprise={t(addonsIncluded)}
      />
    </SectionWrapper>
  );
};
